import { Text as BaseText } from '~components';
import styled from 'styled-components';

export const Text = styled(BaseText)`
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Description = styled(BaseText)`
  font-weight: ${({ theme }) => theme.font.weight.regular};
`;

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.km4};

  > h4 {
    margin-bottom: 16px;
  }
`;

export const List = styled.ul`
  margin-top: ${({ theme }) => theme.spacing.km4};
  margin-left: ${({ theme }) => theme.spacing.km4};
`;

export const Item = styled.li`
  font-family: ${({ theme }) => theme.font.family.body};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: 150%;
  color: ${({ theme }) => theme.color.text.neutral.default};
`;
